import React, { useEffect, useState, useContext } from "react";
import DataTable from "react-data-table-component";
import QueriesDocumentPop from "./QueriesDocumentPop";
import { customData } from "../dummy";
import { IoSearchOutline } from "react-icons/io5";
import { FaInfoCircle } from "react-icons/fa";
import { Tooltip } from "react-tooltip";
import TicketPopup from "./TicketPopup";
import { TbReload } from "react-icons/tb";
import { AppContext } from "../../../ContextApi";
import { AiFillCloseCircle } from "react-icons/ai";

const EmployeeQueriesList = ({
  queriesListData,
  loading,
  setQueriesListData,
  filteredQueriesData,
  setFilteredQueriesData,
  setViewType,
  viewType,
  setSelectedQueryId,
  selectedQueryId,
  setTicketDetailsData,
  ticketDetailsData,
  repliesData, setRepliesData
}) => {
  const [showPopup, setShowPopup] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [callSearchData, setSearchData] = useState(false);
  const [showTicketPopup, setShowTicketPoup] = useState(false);

  const { setCallQueryListApi, callQueryListApi } = useContext(AppContext);

  const handleClose = () => setShowPopup(false);

  const handleUploadedDocs = (document) => {
    setSelectedDoc(document);
    setShowPopup(true);
  };

  function universalFilter(data, searchTerm) {
    const lowerTerm = String(searchTerm).toLowerCase();

    const filterKeys = [
      "category",
      "status",
      "query",
      "last_reply",
      "ticket_id",
    ];

    const filteredData = data.filter((item) =>
      filterKeys.some((key) => {
        const value = item[key];
        return (
          value !== null && String(value).toLowerCase().includes(lowerTerm)
        );
      })
    );
    setSearchData(true);

    setFilteredQueriesData(filteredData);
  }

  useEffect(() => {
    if (searchTerm == "") {
      setFilteredQueriesData(null);
    }
  }, [searchTerm]);

  const columns = [
    {
      name: "# Ticket Id",
      selector: (row) => row.ticket_id || "—",
      sortable: true,
    },
    {
      name: "Category",
      selector: (row) => row.category,
      sortable: true,
    },
    {
      name: "Query",
      selector: (row) => row.query,
      sortable: true,
      cell: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
            width: "250px", // or any fixed width
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          <span
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              flex: 1, // take up remaining space
            }}
          >
            {row.query}
          </span>
          <FaInfoCircle
            data-tooltip-id={`query-tooltip-${row.id}`}
            data-tooltip-content={row.query}
            style={{
              color: "rgb(227 6 111)",
              cursor: "pointer",
              flexShrink: 0,
            }}
          />
          <Tooltip id={`query-tooltip-${row.id}`} />
        </div>
      ),
    },
    {
      name: "Documents",
      cell: (row) => (
        <button
          className="btn-doc"
          onClick={() => handleUploadedDocs(row.documents)}
        >
          View
          {/* Docs ({row.documents.length}) */}
        </button>
      ),
    },
    {
      name: "Last Reply",
      selector: (row) => row.last_reply || "—",
      wrap: true,
    },
    {
      name: "Status",
      cell: (row) => (
        <div className="query-status-box-cover">
          <h6
            className={
              row.status.toLowerCase() == "open"
                ? "open-status query-status-box"
                : row.status.toLowerCase() == "resolved"
                ? "resolve-status query-status-box"
                : "close-status query-status-box"
            }
          >
            {row.status}
          </h6>
        </div>
      ),
    },
    {
      name: "Action",
      cell: (row) => (
        <button className="btn-doc" onClick={() => handleTicketPop(row)}>
          View Tickets
        </button>
      ),
    },
  ];

  const RowStyles = {
    rows: {
      style: {
        backgroundColor: "#fff",
        minHeight: "56px",
        borderBottom: "1px solid #e5e7eb", // subtle border
        fontSize: "14px",
        color: "#374151", // slate-700
        "&:hover": {
          backgroundColor: "#f3f4f6", // hover:bg-gray-100
        },
      },
    },
    headCells: {
      style: {
        backgroundColor: "#f9fafb", // light gray background
        fontWeight: 500,
        fontSize: "12px",
        color: "#111827", // slate-900
        paddingTop: "8px",
        paddingBottom: "8px",
        borderBottom: "1px solid #e5e7eb", // gray border
        minHeight: "40px !important",
      },
    },
    cells: {
      style: {
        paddingTop: "10px",
        paddingBottom: "10px",
        paddingLeft: "16px",
        paddingRight: "16px",
        fontSize: "12px",
      },
    },
  };

  const handleFilter = () => {
    universalFilter(queriesListData, searchTerm);
  };

  const handleTicketPop = (document) => {
    setSelectedQueryId(document.id);
    setShowTicketPoup(true);
    setTicketDetailsData(document);
  };

  useEffect(() => {
    if (searchTerm?.length == 0) {
      setSearchData(false);
    }
  }, [searchTerm]);

  return (
    <div className="employee-queries-list-main-cover-wrapper">
      <button
        className="refresh-data-btn"
        onClick={() => setCallQueryListApi(!callQueryListApi)}
      >
        <TbReload />
        Refresh
      </button>
      <DataTable
        columns={columns}
        data={
          searchTerm && callSearchData ? filteredQueriesData : queriesListData
        }
        pagination
        paginationTotalRows={
          searchTerm && callSearchData
            ? filteredQueriesData?.length
            : queriesListData?.length
        }
        paginationDefaultPage={1}
        rowsPerPage={16}
        progressPending={loading}
        className="custom-datatable"
        customStyles={RowStyles}
        subHeader
        subHeaderComponent={
          <div className="datatable-header-component">
            <div className="search-input-box">
              <input
                className="form-control"
                type="text"
                placeholder="Search..."
                onChange={(e) => setSearchTerm(e.target.value)}
                value={searchTerm}
              />
              {searchTerm?.length > 0 && (
                <button className="clear-search-text" onClick={() => setSearchTerm("")}>
                  <AiFillCloseCircle
                    className=""
                    
                  />
                </button>
              )}
            </div>
            <div className="search-btn-box">
              <button onClick={() => handleFilter()}>
                <IoSearchOutline />
                Search
              </button>
            </div>
          </div>
        }
      />

      <QueriesDocumentPop
        selectedDoc={selectedDoc}
        show={showPopup}
        handleClose={handleClose}
      />
      <TicketPopup
        show={showTicketPopup}
        setShowTicketPoup={setShowTicketPoup}
        setViewType={setViewType}
        selectedQueryId={selectedQueryId}
        ticketDetailsData={ticketDetailsData}
        setRepliesData={setRepliesData}
        repliesData={repliesData}
      />
    </div>
  );
};

export default EmployeeQueriesList;
